import { useState, useCallback } from "react";

/**
 *
 * @param {(value: string) => string} validator A function that gets the value of the input, and returns a string with an error if the input is not valid, or an empty string otherwise
 * @returns {{value: string, error: string, onInputChange: (ev: React.ChangeEvent) => void}} An object containing the value of the input, the error string, and the event handler to attach to the onChange event.
 */
const useValidation = (value, setValue, validator) => {
  const [error, setError] = useState("");

  const onInputChange = useCallback(
    ev => {
      setValue(ev.target.value);
      if (validator) {
        setError(validator(ev.target.value));
      }
    },
    [validator, setValue]
  );

  return { value, error, onInputChange };
};

export default useValidation;
